import { render, staticRenderFns } from "./NotificationsManagement.vue?vue&type=template&id=6bf47a90&"
import script from "./NotificationsManagement.vue?vue&type=script&lang=js&"
export * from "./NotificationsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports